module.exports = __webpack_public_path__ + "static/media/Rainfall_Worried.4cc502eb.gif";